/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 816);
/******/ })
/************************************************************************/
/******/ ({

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(817);
var outdatedBrowser = __webpack_require__(818);
var lang = [];
lang['en'] = __webpack_require__(819);
lang['fr'] = __webpack_require__(820);
lang['pt'] = __webpack_require__(821);
lang['de'] = __webpack_require__(822);
lang['es'] = __webpack_require__(823);
lang['it'] = __webpack_require__(824);
lang['nl'] = __webpack_require__(825);
//event listener: DOM ready
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function() {
            if (oldonload) {
                oldonload();
            }
            func();
        }
    }
}
//call plugin function after DOM ready
addLoadEvent(function(){
    var userLang = navigator.language || navigator.userLanguage || 'en';
    userLang = userLang.slice(2);
    var languages = /en|fr|pt|de|es|it|nl/;
    userLang = userLang.match(languages) ? userLang : 'en';
    var outdated = document.getElementById("outdated");
    outdated.innerHTML = lang[userLang];
    outdatedBrowser({
        bgColor: '#f25648',
        color: '#ffffff',
        lowerThan: 'IE10',
        languagePath: ''
    })
});



/***/ }),

/***/ 817:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

/*!--------------------------------------------------------------------
JAVASCRIPT "Outdated Browser"
Version:    1.1.2 - 2015
author:     Burocratik
website:    http://www.burocratik.com
* @preserve
-----------------------------------------------------------------------*/
var outdatedBrowser=function(t){function o(t){s.style.opacity=t/100,s.style.filter="alpha(opacity="+t+")"}function e(t){o(t),1==t&&(s.style.display="block"),100==t&&(u=!0)}function r(){var t=document.getElementById("btnCloseUpdateBrowser"),o=document.getElementById("btnUpdateBrowser");s.style.backgroundColor=bkgColor,s.style.color=txtColor,s.children[0].style.color=txtColor,s.children[1].style.color=txtColor,o.style.color=txtColor,o.style.borderColor&&(o.style.borderColor=txtColor),t.style.color=txtColor,t.onmousedown=function(){return s.style.display="none",!1},o.onmouseover=function(){this.style.color=bkgColor,this.style.backgroundColor=txtColor},o.onmouseout=function(){this.style.color=txtColor,this.style.backgroundColor=bkgColor}}function l(){var t=!1;if(window.XMLHttpRequest)t=new XMLHttpRequest;else if(window.ActiveXObject)try{t=new ActiveXObject("Msxml2.XMLHTTP")}catch(o){try{t=new ActiveXObject("Microsoft.XMLHTTP")}catch(o){t=!1}}return t}function a(t){var o=l();return o&&(o.onreadystatechange=function(){n(o)},o.open("GET",t,!0),o.send(null)),!1}function n(t){var o=document.getElementById("outdated");return 4==t.readyState&&(o.innerHTML=200==t.status||304==t.status?t.responseText:d,r()),!1}var s=document.getElementById("outdated");this.defaultOpts={bgColor:"#f25648",color:"#ffffff",lowerThan:"transform",languagePath:"../outdatedbrowser/lang/en.html"},t?("IE8"==t.lowerThan||"borderSpacing"==t.lowerThan?t.lowerThan="borderSpacing":"IE9"==t.lowerThan||"boxShadow"==t.lowerThan?t.lowerThan="boxShadow":"IE10"==t.lowerThan||"transform"==t.lowerThan||""==t.lowerThan||"undefined"==typeof t.lowerThan?t.lowerThan="transform":("IE11"==t.lowerThan||"borderImage"==t.lowerThan)&&(t.lowerThan="borderImage"),this.defaultOpts.bgColor=t.bgColor,this.defaultOpts.color=t.color,this.defaultOpts.lowerThan=t.lowerThan,this.defaultOpts.languagePath=t.languagePath,bkgColor=this.defaultOpts.bgColor,txtColor=this.defaultOpts.color,cssProp=this.defaultOpts.lowerThan,languagePath=this.defaultOpts.languagePath):(bkgColor=this.defaultOpts.bgColor,txtColor=this.defaultOpts.color,cssProp=this.defaultOpts.lowerThan,languagePath=this.defaultOpts.languagePath);var u=!0,i=function(){var t=document.createElement("div"),o="Khtml Ms O Moz Webkit".split(" "),e=o.length;return function(r){if(r in t.style)return!0;for(r=r.replace(/^[a-z]/,function(t){return t.toUpperCase()});e--;)if(o[e]+r in t.style)return!0;return!1}}();if(!i(""+cssProp)){if(u&&"1"!==s.style.opacity){u=!1;for(var c=1;100>=c;c++)setTimeout(function(t){return function(){e(t)}}(c),8*c)}" "===languagePath||0==languagePath.length?r():a(languagePath);var d='<h6>Your browser is out-of-date!</h6><p>Update your browser to view this website correctly. <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">Update my browser now </a></p><p class="last"><a href="#" id="btnCloseUpdateBrowser" title="Close">&times;</a></p>'}};

/*** EXPORTS FROM exports-loader ***/
module.exports = outdatedBrowser;

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

module.exports = " <h6>Your browser is out of date!</h6> <p>Update your browser to view this website correctly. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/ >Update my browser now </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Close>&times;</a></p> ";

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

module.exports = " <h6>Votre navigateur est obsolète!</h6> <p>Mettez à jour votre navigateur pour afficher correctement ce site Web. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/fr>Mettre à jour maintenant </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Fermer>&times;</a></p> ";

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

module.exports = " <h6>O seu browser est&aacute; desatualizado!</h6> <p>Atualize o seu browser para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/pt>Atualize o seu browser agora</a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Fechar>&times;</a></p> ";

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

module.exports = " <h6>Ihr Browser ist veraltet!</h6> <p>Bitte aktualisieren Sie Ihren Browser, um diese Website korrekt dazustellen. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/de>Den Browser jetzt aktualisieren </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Schließen>&times;</a></p> ";

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

module.exports = " <h6>¡Tu navegador está obsoleto!</h6> <p>Actualiza tu navegador para ver esta página correctamente. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/es>Actualizar mi navegador ahora</a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Cerrar>&times;</a></p> ";

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

module.exports = " <h6>Il tuo browser non &egrave; aggiornato!</h6> <p>Aggiornalo per vedere questo sito correttamente. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/it>Aggiorna ora</a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Chiudi>&times;</a></p> ";

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

module.exports = " <h6>Je gebruikt een verouderde browser!</h6> <p>Update je browser om deze website correct te bekijken. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/nl>Update mijn browser nu </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Sluiten>&times;</a></p> ";

/***/ })

/******/ });


// WEBPACK FOOTER //
// scripts/outdatedBrowser-e3c6c9.js